import React, { useState, useEffect } from 'react';
import { Form, Row, Col, Alert } from 'react-bootstrap';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { formatNumber } from '../../../utils/formatNumber';
import PutyovkaService from "../../../services/PutyovkaService";

const Step1BasicInfo = ({ formData, updateFormData, options, transportId, muddatUzaytirish = false, setMuddatUzaytirish = () => {}, isEdit }) => {
  const [errors, setErrors] = useState({});

  console.log('formdata step 1 dagi', formData)
  const [localFormData, setLocalFormData] = useState({
    transport_id: formData.transport_id || '',
    raqam: formData.raqam || '',
    raqamOld: formData.raqam || '',
    narx: formData.narx || '',
    dan: formData.dan ? new Date(formData.dan) : new Date(),
    gacha: formData.gacha ? new Date(formData.gacha) : new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)
  });
  const formDataNumber = formData.raqam ? formData.raqam : '';

  // Update parent form data when local form data changes
  useEffect(() => {
    // Only update if there are actual changes
    const shouldUpdate = Object.keys(localFormData).some(
      key => JSON.stringify(formData[key]) !== JSON.stringify(localFormData[key])
    );
    
    if (shouldUpdate) {
      updateFormData(localFormData);
    }
  }, [localFormData, updateFormData, formData]);

  useEffect(() => {
    console.log('muddatUzaytirish', muddatUzaytirish)
  }, [muddatUzaytirish])

  const handleChange = React.useCallback((e) => {
    const { name, value } = e.target;
    let newValue = value;
    if (name === 'raqam'){
      // Faqat raqamlarni qoldirish (0-9)
      newValue = value.replace(/\D/g, ''); // \D - not digits
      setLocalFormData(prev => ({
        ...prev,
        [name]: newValue
      }));
    }else {
      setLocalFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }

  }, []);

  const handleTransportChange = React.useCallback((selectedOption) => {
    const transportId = selectedOption ? selectedOption.value : '';
    setLocalFormData(prev => ({
      ...prev,
      transport_id: transportId
    }));
  }, []);

  const handleDateChange = React.useCallback((date, field) => {
    setLocalFormData(prev => ({
      ...prev,
      [field]: date
    }));
  }, []);

  const handleNarxChange = React.useCallback((e) => {
    const rawValue = e.target.value.replace(/\D/g, '');
    const formattedValue = formatNumber(rawValue);
    
    setLocalFormData(prev => ({
      ...prev,
      narx: rawValue
    }));
  }, []);

  // Validate form
  const validateForm = () => {
    const newErrors = {};
    
    if (!localFormData.transport_id || localFormData.transport_id === '') {
      newErrors.transport_id = 'Transportni tanlang';
    }
    
    if (!localFormData.raqam || localFormData.raqam.trim() === '') {
      newErrors.raqam = 'Putyovka raqamini kiriting';
    }
    
    if (!localFormData.narx || localFormData.narx.trim() === '') {
      newErrors.narx = 'Narxni kiriting';
    }
    
    if (!localFormData.dan) {
      newErrors.dan = 'Boshlanish sanasini tanlang';
    }
    
    if (!localFormData.gacha) {
      newErrors.gacha = 'Tugash sanasini tanlang';
    } else if (localFormData.dan && localFormData.gacha < localFormData.dan) {
      newErrors.gacha = 'Tugash sanasi boshlanish sanasidan keyin bo\'lishi kerak';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Validate on next step
  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      validateForm();
    }
  }, [localFormData]);

  return (
    <div className="pw-form">
      <h5 className="mb-4">Asosiy maʼlumotlar</h5>
      
      <Row className="mb-3">
        <Col md={6}>
          <Form.Group controlId="transport_id">
            <Form.Label>Transport <span className="pw-text-danger">*</span></Form.Label>
            <Select
              value={options.transports.find(opt => opt.value === localFormData.transport_id) || null}
              onChange={handleTransportChange}
              options={options.transports}
              placeholder="Transportni tanlang..."
              isClearable
              isSearchable
              className={errors.transport_id ? 'is-invalid' : ''}
              isDisabled={transportId}
            />
            {errors.transport_id && (
              <Form.Text className="pw-text-danger">{errors.transport_id}</Form.Text>
            )}
          </Form.Group>
        </Col>
        
        <Col md={6}>
          <Form.Group controlId="raqam">
            <Form.Label>Putyovka raqami</Form.Label>
            <Form.Control
              type="text"
              name="raqam"
              value={localFormData.raqam}
              onChange={handleChange}
              placeholder="Putyovka raqamini kiriting"
              isInvalid={!!errors.raqam}
            />
            <Form.Control.Feedback type="invalid">
              {errors.raqam}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>
      
      <Row className="mb-3">
        <Col md={6}>
          <Form.Group controlId="narx">
            <Form.Label>Narx (so'm) <span className="pw-text-danger">*</span></Form.Label>
            <Form.Control
              type="text"
              name="narx"
              value={localFormData.narx ? formatNumber(localFormData.narx) : ''}
              onChange={handleNarxChange}
              placeholder="Narxni kiriting"
              isInvalid={!!errors.narx}
            />
            <Form.Control.Feedback type="invalid">
              {errors.narx}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        {isEdit && (
            <Col md={6} className="d-flex align-items-end gap-3 mt-3">
              <Form.Group controlId="muddat">
                {/*<Form.Label>Narx (so'm) <span className="pw-text-danger">*</span></Form.Label>*/}
                {/* Checkboxni shu yerga qo‘shamiz */}
                <Form.Check
                    type="checkbox"
                    label="Muddat uzaytirish"
                    name="muddatUzaytirish"
                    checked={muddatUzaytirish}
                    onChange={async (e) =>{
                      setMuddatUzaytirish(!muddatUzaytirish);
                      if (!muddatUzaytirish){
                        let lastIndex = await PutyovkaService.getLastIndex();
                        console.log('mana lasr index', lastIndex)
                        const lastPutyovkaNumber = lastIndex?.data?.raqam + 1 || '';
                        setLocalFormData(prev => ({
                          ...prev,
                          raqam: lastPutyovkaNumber
                        }));
                        console.log(localFormData)
                      }else {
                        console.log("form data indexi", localFormData.raqamOld)
                        setLocalFormData(prev => ({
                          ...prev,
                          raqam: localFormData.raqamOld
                        }));
                      }
                    }

                    }
                    className="mt-2"
                />
              </Form.Group>
            </Col>
        )}

      </Row>
      
      <Row>
        <Col md={6}>
          <Form.Group controlId="dan">
            <Form.Label>Boshlanish sanasi <span className="pw-text-danger">*</span></Form.Label>
            <div>
              <DatePicker
                selected={localFormData.dan}
                onChange={(date) => handleDateChange(date, 'dan')}
                selectsStart
                startDate={localFormData.dan}
                endDate={localFormData.gacha}
                className={`form-control ${errors.dan ? 'is-invalid' : ''}`}
                dateFormat="dd.MM.yyyy"
                placeholderText="Sanani tanlang"
              />
              {errors.dan && (
                <div className="invalid-feedback d-block">
                  {errors.dan}
                </div>
              )}
            </div>
          </Form.Group>
        </Col>
        
        <Col md={6}>
          <Form.Group controlId="gacha">
            <Form.Label>Tugash sanasi <span className="pw-text-danger">*</span></Form.Label>
            <div>
              <DatePicker
                selected={localFormData.gacha}
                onChange={(date) => handleDateChange(date, 'gacha')}
                selectsEnd
                startDate={localFormData.dan}
                endDate={localFormData.gacha}
                minDate={localFormData.dan}
                className={`form-control ${errors.gacha ? 'is-invalid' : ''}`}
                dateFormat="dd.MM.yyyy"
                placeholderText="Sanani tanlang"
              />
              {errors.gacha && (
                <div className="invalid-feedback d-block">
                  {errors.gacha}
                </div>
              )}
            </div>
          </Form.Group>
        </Col>
      </Row>
      
      <div className="pw-alert pw-alert-info mt-4">
        <p className="mb-0">
          <i className="fas fa-info-circle me-2"></i>
          Iltimos, barcha maydonlarni to'g'ri to'ldiring. Majburiy maydonlar <span className="pw-text-danger">*</span> belgisi bilan belgilangan.
        </p>
      </div>
    </div>
  );
};

export default Step1BasicInfo;
